export const calculatePageBgStyles = (
  numberOfPages,
  selectedPage,
  hasPageAnimation,
  hasUploadedWallpaper
) => {
  if (hasUploadedWallpaper) {
    if (hasPageAnimation === false) {
      return {
        background: `var(--canvas-wallpaper) no-repeat center/cover, var(--canvas-bg-color)`,
        width: '100vw',
      };
      // otherwise we size the image dynamically to the no. of pages
    } else {
      return {
        background: `var(--canvas-wallpaper) no-repeat center/cover, var(--canvas-bg-color)`,
        width: `${100 + 5 * numberOfPages}vw`,
        transform: `translate(-${5 * selectedPage}vw, 0)`,
      };
    }
  } else {
    return {
      background: `var(--canvas-bg-color)`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'top center',
      width: `${100 + 5 * numberOfPages}vw`,
      transform: `translate(-${5 * selectedPage}vw, 0)`,
    };
  }
};
